if ($(".template-product")[0]) {
    $(".productView-image-wrapper .media img").removeAttr('sizes')
}


$(document).ready(function(){
  setTimeout(function(){
    $("#tab-description .toggleLink").addClass("is-open");
    $("#tab-description .toggle-content").css("display", "block");
  }, 1000);
});


// ******************************************** DESKTOP VIEW ********************************************************

$(document).ready(function () {
  
      // $("#HeaderNavigation ul.list-menu li:nth-child(1)").addClass("custom-mega-menu2");
  
      $("body").hover(function () {
        
        setTimeout(function () {
            $("#HeaderNavigation ul.list-menu li:nth-child(1)").addClass("custom-mega-menu2");
            $(".custom-mega-menu2 .menu-dropdown .menu-dropdown__column .site-nav .site-nav-title").each(function (index) {
            $(this).addClass('desktop-class-img desktop-class-' + (index + 1)).css({
                  'display': 'flex',
                  'flex-direction': 'column',
                  'align-items': 'center'
              });
            });
            // $(".class-1").css("color", "red");
            if ($('#submenu-image1').length === 0) {
              $('.desktop-class-1').append('<img id="submenu-image1" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/Asig_Icon_6530f9eb-f374-4447-8641-7bef811d5c3a.png?v=1720607445" />');
            }
            if ($('#submenu-image2').length === 0) {
              $('.desktop-class-2').append('<img id="submenu-image2" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/phi_gamma_delta_icon_be0de6dc-4db7-4be8-81ba-79f91f3011ce.png?v=1700116031" />');
            }
            if ($('#submenu-image3').length === 0) {
              $('.desktop-class-3').append('<img id="submenu-image3" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_chi_icon1.png?v=1700116031" />');
            }
            if ($('#submenu-image4').length === 0) {
              $('.desktop-class-4').append('<img id="submenu-image4" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/delta_tau_delta_icon_b6717160-d1a2-4fde-aa46-f80402b9895d.png?v=1700046930" />');
            }
            if ($('#submenu-image5').length === 0) {
              $('.desktop-class-5').append('<img id="submenu-image5" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/pikapp_icon_167fa2fd-1d86-4854-9faa-6c941cc5ee26.png?v=1720609180" />');
            }
            if ($('#submenu-image6').length === 0) {
              $('.desktop-class-6').append('<img id="submenu-image6" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_phi_epsilon_icon_abdd7427-8273-4544-ae08-8f06e168bac7.png?v=1700116031" />');
            }
            if ($('#submenu-image7').length === 0) {
              $('.desktop-class-7').append('<img id="submenu-image7" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/kappa_sigma_icon_e51a5d9d-7ed1-4cf9-aa58-ff5430ebdca9.png?v=1700116031" />');
            }
            if ($('#submenu-image8').length === 0) {
              $('.desktop-class-8').append('<img id="submenu-image8" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/pi_kappa_alpha_icon_c884fdbc-1de0-4f3b-b310-0160a7a81a66.png?v=1700116031" />');
            }
            if ($('#submenu-image9').length === 0) {
              $('.desktop-class-9').append('<img id="submenu-image9" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/tke_icon_b93f11d9-f88f-411d-88ff-ff1e9e4eccc5.png?v=1720609180" />');
            }          
            if ($('#submenu-image10').length === 0) {
              $('.desktop-class-10').append('<img id="submenu-image10" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/lambda_chi_alpha_icon_2288be00-1b9e-4457-925d-3269c442c505.png?v=1700116031" />');
            }
            if ($('#submenu-image11').length === 0) {
              $('.desktop-class-11').append('<img id="submenu-image11" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_alpha_epsilon_icon_fd8d8b3a-0a8c-4181-8b8b-1c54c298097f.png?v=1700116031" />');
            }
            if ($('#submenu-image12').length === 0) {
              $('.desktop-class-12').append('<img id="submenu-image12" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/theta_chi_icon_20e2519f-23ff-450a-985b-8df43b7023f4.png?v=1700116031" />');
            }
          
        }, 1000);
        
      });

      
});

// ******************************************** MOBILE VIEW ********************************************************

$(document).ready(function () {
  $(".mobileMenu-toggle").click(function () {
    setTimeout(function () {
      $("#navigation-mobile ul.list-menu li:nth-child(2)").addClass("custom-mega-menu");
      
      // $('.custom-mega-menu .menu-dropdown__column .site-nav .site-nav-title span').addClass("class-1");
      
      $(".custom-mega-menu .menu-dropdown__column .site-nav .site-nav-title").each(function (index) {
        $(this).addClass('class-' + (index + 1)).css({
            'display': 'flex',
            'align-items': 'center'
        });
      });
      // $(".class-1").css("color", "red");
      $('.class-1').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/Asig_Icon_6530f9eb-f374-4447-8641-7bef811d5c3a.png?v=1720607445" />');
      $('.class-2').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/delta_tau_delta_icon_b6717160-d1a2-4fde-aa46-f80402b9895d.png?v=1700046930" />');
      $('.class-3').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/kappa_sigma_icon_e51a5d9d-7ed1-4cf9-aa58-ff5430ebdca9.png?v=1700116031" />');
      $('.class-4').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/lambda_chi_alpha_icon_2288be00-1b9e-4457-925d-3269c442c505.png?v=1700116031" />');
      $('.class-5').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/phi_gamma_delta_icon_be0de6dc-4db7-4be8-81ba-79f91f3011ce.png?v=1700116031" />');
      $('.class-6').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/pikapp_icon_167fa2fd-1d86-4854-9faa-6c941cc5ee26.png?v=1720609180" />');
      $('.class-7').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/pi_kappa_alpha_icon_c884fdbc-1de0-4f3b-b310-0160a7a81a66.png?v=1700116031" />');
      $('.class-8').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_alpha_epsilon_icon_fd8d8b3a-0a8c-4181-8b8b-1c54c298097f.png?v=1700116031" />');
      $('.class-9').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_chi_icon1.png?v=1700116031" />');
      $('.class-10').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/sigma_phi_epsilon_icon_abdd7427-8273-4544-ae08-8f06e168bac7.png?v=1700116031" />');
      $('.class-11').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/tke_icon_b93f11d9-f88f-411d-88ff-ff1e9e4eccc5.png?v=1720609180" />');
      $('.class-12').prepend('<img id="submenu-image" src="https://cdn.shopify.com/s/files/1/0713/3842/6648/files/theta_chi_icon_20e2519f-23ff-450a-985b-8df43b7023f4.png?v=1700116031" />');
      
    }, 1000);
  });
});











